"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceOutputFilterMiddleware = void 0;
const AbstractAuthorizerMiddleware_1 = require("../Middlewares/AbstractAuthorizerMiddleware");
const types_1 = require("../types");
const debugLog_1 = __importDefault(require("../Utils/debugLog"));
class ResourceOutputFilterMiddleware extends AbstractAuthorizerMiddleware_1.AbstractAuthorizerMiddleware {
    async filterResourcesForUserByAction(resources, userId, action = types_1.ACTION_NAME.READ) {
        const filterPromises = resources.map(async (resource) => {
            const resourceName = resource.getSRN().toString();
            const isAllowed = await this.enforcer.enforce(userId, action, resourceName);
            (0, debugLog_1.default)('ResourceOutputFilterMiddleware.filterResourcesForUserByAction', `${isAllowed ? 'ALLOW' : 'DENY'} ${resourceName}`);
            if (isAllowed) {
                return resource;
            }
            return null;
        });
        const resolvedFilterPromises = await Promise.all(filterPromises);
        return resolvedFilterPromises.filter((resource) => resource !== null);
    }
}
exports.ResourceOutputFilterMiddleware = ResourceOutputFilterMiddleware;
//# sourceMappingURL=ResourceOutputFilterMiddleware.js.map